import React from "react";
import { useSession } from "@/contexts/session";
import { useRouter } from "next/navigation";

import { TenantLogo as Logo } from "@/tenants/components/TenantLogo";

export const TenantLogo = () => (
	<Logo className="w-[96px] text-inherit md:w-[118px]" />
);

export const TenantLogoLink = () => {
	const router = useRouter();
	const { hasAuthenticatedSession } = useSession();
	return (
		<button
			aria-label="Home"
			onClick={() => router.push(hasAuthenticatedSession ? "/portfolio" : "/")}
			className="text-white"
			type="button"
		>
			<Logo />
		</button>
	);
};
